import axios from "axios";
import API from './index'

export default {
    delete(route, successCallback, errorCallback) {
        const url =  API.BASE_URL + route
        console.log("Delete: ", url)
        return axios.delete(url)
            .then(response => {
                console.log("Delete response from ", url)
                console.log(response)
                successCallback(response)
            })
            .catch(error => {
                console.log("Delete error from ", url)
                console.log(error)
                if(error.response){
                    errorCallback(error.response.data)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
            })
    },

    get(route, successCallback, errorCallback) {
        // console.log("ApiUrl: ", settings.get('apiUrl'))
        const url = API.BASE_URL + route;
        console.log("Get: ", url)
        return axios.get(url)
            .then((response) => {
                logResponse(response, url, "Get response from ")
                successCallback(response);
            })
            .catch(error => {
                logResponse(error, url, "Get error from")
                if (error.response) {
                    errorCallback(error.response)
            } else {
                errorCallback(error)
            }
        })
            .finally(() => {
            })
    },

    post(url, data, successCallback, errorCallback) {
        const route = API.BASE_URL + url;
        console.log("Post: ", data)
        return axios.post(route, data)
            .then((response) => {
                logResponse(response, url, "Post response from ")
                successCallback(response);
            })
            .catch(error => {
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
                console.log("Post error:", error)
            })
            .finally(() => {
            })
    },

    put(url, data, successCallback, errorCallback) {
        console.log("Put: ", data)
        return axios.put(url, data)
            .then((response) => {
                logResponse(response, url, "Put response from ")
                successCallback(response);
            })
            .catch(error => {
                console.log("Put error from ", url)
                console.log(error)
                if (error.response) {
                    errorCallback(error.response)
                } else {
                    errorCallback(error)
                }
            })
            .finally(() => {
            })
    },
}

function logResponse(response, url, message) {
    console.log(message, url)
    console.log(response)
}